export default {
  ADD_OTHER_WIDGETS: "ADD_OTHER_WIDGETS",
  LINE_BAR_CHART: "LINE_BAR_CHART",
  TIME_SERIES: "TIME_SERIES",
  TIME_SERIES_VERTICAL: "TIME_SERIES_VERTICAL",
  RANGE_LINE_CHART: "RANGE_LINE_CHART",
  STUDIO_CHART: "STUDIO_CHART",
  PIE_CHART: 'PIE_CHART',
  TEXTUAL: "TEXTUAL",
  GAUGE: 'GAUGE',
  VERTICAL_AREA_BAR: 'VERTICAL_AREA_BAR',
  TABLE: 'TABLE',
  TREE_MAP: 'TREE_MAP',
  CONTROL_WIDGET: 'CONTROL_WIDGET',
  TECHNICAL_ANALYSIS_CHART: 'TECHNICAL_ANALYSIS_CHART',
  MAP: "MAP",
  SPREADSHEET: "SPREADSHEET",
  BULLET_VERTICAL: "BULLET_VERTICAL",
  SEPARATOR_VERTICAL: "SEPARATOR_VERTICAL",
  RANK_WIDGET: "RANK_WIDGET",
  TRADING_VIEW: "TRADING_VIEW"
}


// WEBPACK FOOTER //
// ./src/core/constants/widgetType.js